'use strict';

var wheelForm = $('[data-js="wof__btn-submit"]');

wheelForm.on('click', function (e) {
    var spinImageStatic = $('[data-js="wof__wheel-static"]');
    var spinImageAnimated = $('[data-js="wof__wheel-animated"]');
    spinImageStatic.addClass('is-hidden');
    spinImageAnimated.addClass('is-visible');
});
